var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isPageFullyLoaded)?_c('Loading'):_vm._e(),_c('Portfolio',{on:{"portfolio-loaded":function($event){_vm.isPageFullyLoaded = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }